import { actionTypes as resourceActions } from 'redux-resource';
import * as types from './types';

/*
 * getAll actions
 */
export const getAll = (userId) => ({
  type: types.GET_ALL,
  payload: {
    userId
  },
});

const getAllDefaults = {
  requestKey: 'getAll',
  resourceType: 'purchases',
};

export const getAllPending = () => ({
  ...getAllDefaults,
  type: resourceActions.READ_RESOURCES_PENDING,
});

export const getAllSucceeded = (response) => ({
  ...getAllDefaults,
  type: resourceActions.READ_RESOURCES_SUCCEEDED,
  resources: response.data.results,
});

export const getAllFailed = () => ({
  ...getAllDefaults,
  type: resourceActions.READ_RESOURCES_FAILED,
});

/*
 * Find actions
 */

export const find = (purchaseId) => ({
  type: types.FIND,
  payload: {
    purchaseId,
  }
});

const findDefaults = {
  requestKey: 'find',
  resourceType: 'purchases',
}

export const findPending = () => ({
  ...findDefaults,
  type: resourceActions.READ_RESOURCES_PENDING,
})

export const findSucceeded = (response) => ({
  ...findDefaults,
  type: resourceActions.READ_RESOURCES_SUCCEEDED,
  resources: [response.data]
});

export const findFailed = () => ({
  ...findDefaults,
  type: resourceActions.READ_RESOURCES_FAILED,
});

/*
 * createRenewal actions
 */
export const createRenewal = (userId) => ({
  type: types.CREATE_RENEWAL,
  payload: { userId }
});

const createRenewalDefaults = {
  requestKey: 'createRenewal',
  resourceType: 'purchases',
}

export const createRenewalPending = () => ({
  ...createRenewalDefaults,
  type: resourceActions.CREATE_RESOURCES_PENDING
});

export const createRenewalSucceeded = (response) => ({
  ...createRenewalDefaults,
  type: resourceActions.CREATE_RESOURCES_SUCCEEDED,
  resources: [response.data]
});

export const createRenewalFailed = () => ({
  ...createRenewalDefaults,
  type: resourceActions.CREATE_RESOURCES_FAILED,
});

export const destroy = (id) => ({
  type: types.DESTROY,
  payload: { id }
});

const destroyDefaults = {
  resourceType: 'purchases',
  requestKey: 'destroy'
}

export const destroyPending = (id) => ({
  ...destroyDefaults,
  type: resourceActions.DELETE_RESOURCES_PENDING,
  resources: [id]
});

export const destroySucceeded = (id) => ({
  ...destroyDefaults,
  type: resourceActions.DELETE_RESOURCES_SUCCEEDED,
  resources: [id]
});

export const destroyFailed = (id) => ({
  ...destroyDefaults,
  type: resourceActions.DELETE_RESOURCES_FAILED,
  resources: [id]
});

export const getHistory = (userId, page = 1) => ({
  type: types.GET_HISTORY,
  payload: {
    userId,
    page
  },
});

export const createSprintUpgrade = (subId, planId) => ({
  type: types.CREATE_SPRINT_UPGRADE,
  payload: {
    subId,
    planId,
  }
});

const createSprintUpgradeDefaults = {
  resourceType: 'purchases',
  requestKey: 'createSprintUpgrade',
}
export const createSprintUpgradePending = () => ({
  ...createSprintUpgradeDefaults,
  type: resourceActions.CREATE_RESOURCES_PENDING,
});
export const createSprintUpgradeSucceeded = (response) => ({
  ...createSprintUpgradeDefaults,
  type: resourceActions.CREATE_RESOURCES_SUCCEEDED,
  resources: [response.data],
});
export const createSprintUpgradeFailed = () => ({
  ...createSprintUpgradeDefaults,
  type: resourceActions.CREATE_RESOURCES_FAILED,
});


export const createAttUpgrade = (subId, planId) => ({
  type: types.CREATE_ATT_UPGRADE,
  payload: {
    subId,
    planId,
  }
});

const createAttUpgradeDefaults = {
  resourceType: 'purchases',
  requestKey: 'createAttUpgrade',
}
export const createAttUpgradePending = () => ({
  ...createAttUpgradeDefaults,
  type: resourceActions.CREATE_RESOURCES_PENDING,
});
export const createAttUpgradeSucceeded = (response) => ({
  ...createAttUpgradeDefaults,
  type: resourceActions.CREATE_RESOURCES_SUCCEEDED,
  resources: [response.data],
});
export const createAttUpgradeFailed = () => ({
  ...createAttUpgradeDefaults,
  type: resourceActions.CREATE_RESOURCES_FAILED,
});

export const createQuickUpgrade = (subId, planId) => ({
  type: types.CREATE_QUICK_UPGRADE,
  payload: {
    subId,
    planId,
  }
});

const createQuickUpgradeDefaults = {
  resourceType: 'purchases',
  requestKey: 'createAttUpgrade',
}
export const createQuickUpgradePending = () => ({
  ...createQuickUpgradeDefaults,
  type: resourceActions.CREATE_RESOURCES_PENDING,
});
export const createQuickUpgradeSucceeded = (response) => ({
  ...createQuickUpgradeDefaults,
  type: resourceActions.CREATE_RESOURCES_SUCCEEDED,
  resources: [response.data],
});
export const createQuickUpgradeFailed = () => ({
  ...createQuickUpgradeDefaults,
  type: resourceActions.CREATE_RESOURCES_FAILED,
});

/*
 * Fetch Filtered Purchases
 */
export const fetchFiltered = (userId, params) => ({
  type: types.FETCH_FILTERED,
  payload: {
    userId,
    params
  }
});

/*
 * create actions
 */
export const create = (userId) => ({
  type: types.CREATE,
  payload: {
    userId,
  }
});

const createDefaults = {
  requestKey: 'create',
  resourceType: 'purchases',
}

export const createPending = () => ({
  ...createDefaults,
  type: resourceActions.CREATE_RESOURCES_PENDING
});

export const createSucceeded = (response) => ({
  ...createDefaults,
  type: resourceActions.CREATE_RESOURCES_SUCCEEDED,
  resources: [response.data]
});

export const createFailed = () => ({
  ...createDefaults,
  type: resourceActions.CREATE_RESOURCES_FAILED,
});


/*
 * addLineItem actions
 */
export const addLineItem = (purchaseId, attrs) => ({
  type: types.CREATE,
  payload: {
    purchaseId,
    attrs,
  }
});

const addLineItemDefaults = {
  requestKey: 'update',
  resourceType: 'purchases',
}

export const addLineItemPending = () => ({
  ...addLineItemDefaults,
  type: resourceActions.CREATE_RESOURCES_PENDING
});

export const addLineItemSucceeded = (response) => ({
  ...addLineItemDefaults,
  type: resourceActions.CREATE_RESOURCES_SUCCEEDED,
  resources: [response.data]
});

export const addLineItemFailed = () => ({
  ...addLineItemDefaults,
  type: resourceActions.CREATE_RESOURCES_FAILED,
});



/*
 * setShippingOptions actions
 */
export const setShippingOptions = (purchaseId, attrs) => ({
  type: types.CREATE,
  payload: {
    purchaseId,
    attrs,
  }
});

const setShippingOptionsDefaults = {
  requestKey: 'update',
  resourceType: 'purchases',
}

export const setShippingOptionsPending = () => ({
  ...setShippingOptionsDefaults,
  type: resourceActions.CREATE_RESOURCES_PENDING
});

export const setShippingOptionsSucceeded = (response) => ({
  ...setShippingOptionsDefaults,
  type: resourceActions.CREATE_RESOURCES_SUCCEEDED,
  resources: [response.data]
});

export const setShippingOptionsFailed = () => ({
  ...setShippingOptionsDefaults,
  type: resourceActions.CREATE_RESOURCES_FAILED,
});

export const recalculateShipping = (purchaseId) => ({
  type: types.CREATE,
  payload: {
    purchaseId,
  }
});

const recalculateShippingDefaults = {
  requestKey: 'update',
  resourceType: 'purchases',
}

export const recalculateShippingPending = () => ({
  ...recalculateShippingDefaults,
  type: resourceActions.CREATE_RESOURCES_PENDING
});

export const recalculateShippingSucceeded = (response) => ({
  ...recalculateShippingDefaults,
  type: resourceActions.CREATE_RESOURCES_SUCCEEDED,
  resources: [response.data]
});

export const recalculateShippingFailed = () => ({
  ...recalculateShippingDefaults,
  type: resourceActions.CREATE_RESOURCES_FAILED,
});

/*
 * mergePurchases actions
 */
const mergePurchasesDefaults = {
  requestKey: 'update',
  resourceType: 'purchases',
}

export const mergePurchases = (purchaseId, attrs, redirectToPurchase = false) => ({
  type: types.MERGE_PURCHASES,
  payload: {
    purchaseId,
    attrs,
    redirectToPurchase,
  }
});

export const mergePurchasesPending = () => ({
  ...mergePurchasesDefaults,
  type: resourceActions.CREATE_RESOURCES_PENDING
});

export const mergePurchasesSucceeded = (response) => ({
  ...mergePurchasesDefaults,
  type: resourceActions.CREATE_RESOURCES_SUCCEEDED,
  resources: [response.data]
});

export const removePurchasesAfterMerge = (purchases) => ({
  ...mergePurchasesDefaults,
  requestKey: 'delete',
  type: resourceActions.DELETE_RESOURCES_SUCCEEDED,
  resources: purchases
});

export const mergePurchasesFailed = () => ({
  ...mergePurchasesDefaults,
  type: resourceActions.CREATE_RESOURCES_FAILED,
});

/*
 * Load lineitems actions
 */

export const loadLineItems = (purchaseId, page) => ({
  type: types.LOAD_LINE_ITEMS,
  payload: {
    purchaseId,
    page,
  }
});
